import React, {Component} from "react";
import * as PropTypes from "prop-types";

export default class UserContext extends Component {

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        const { reportUserIsLoading, reportUserSignedIn, fetchUserAccounts, fetchUserSecurityProfile } = this.props;
        reportUserIsLoading(true);

        fetch('/api/user',
            {
                    method: 'GET',
                    credentials: 'include',
                    headers: {
                        'Accept': 'application/json'
                    }
            })
            .then(response => response.json())
            .then(user => {
                if (user.email === 'john.doe@gmail.com') {
                    console.log("simply loading the sample user john.doe@gmail.com");
                } else {
                    reportUserSignedIn(user);
                }
            })
            .catch(function (err) {
                console.log("error while getting /api/user. Err is: "+err);
            })
            .finally( function () {
                reportUserIsLoading(false);
                fetchUserAccounts();
                fetchUserSecurityProfile();
            })
    }

    render() {
        return (
            <></>
        )
    }
}

UserContext.propTypes = {
    // comes from redux injection via UserContextAdapter //
    reportUserSignedIn: PropTypes.func.isRequired
};